import React, { useState } from "react";
import { Link } from "@reach/router";
import styles from "./MammalChampion.module.scss";
import JoinComponent from "./JoinComponent";
import Username from "./Username";

function InsectChampion(props) {
  const [insectNo, setInsectNo] = React.useState(0);
  const insectQuestions = [
    "We have loads of fantastic benefits if you join our group. We have winged creatures for delivery of messages in a hurry, we have an army of ants to defend your manor, we have wonderful spiders that create bridges for you to cross and we will not eat all your cabbages if you join us. Our Champion is the Cabbage Butterfly we are a misunderstood butterfly who like to dance together and enjoy our five a day consisting of cabbages as they are tasty and succulent. We speak in whispers as we are calm cool and beautiful",
  ];

  let answerNo = insectNo * 2;
  const insectAnswers = ["Join us for fab benefits", "Refuse at your peril"];

  if (insectNo === 0) {
    console.log(insectNo);
    return (
      <div className={styles.bkg}>
        <p>
          Hi I am a Cabbage Butterfly and the insect champion, my scales,
          arranged in colorful designs are what gives me my beauty. We speak in
          whispers as we are calm, cool and beautiful. We insects have loads of
          fantastic benefits if you join our group. We have winged creatures for
          delivery of messages in a hurry, we have an army of ants to defend
          your manor, we have wonderful spiders that create bridges for you to
          cross and we will not eat all your cabbages if you join us. Our NPC's
          are also a great benefit. Look through the game to find out about our
          Brilliant ants, wonderful bees and flies, there are so many benefits
          that you would be amazed. Insects rule! We are the best, look through
          the game and I bet you’ll find us fascinating.
        </p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setInsectNo(1);
            }}
          >
            Join us for fab benefits.
          </button>
        </p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setInsectNo(5);
            }}
          >
            Refuse at your peril.
          </button>
        </p>
        <p>Or would you like to know</p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setInsectNo(8);
            }}
          >
            a bit more about me?
          </button>
        </p>

        <p>Look round for information about our group through the game.</p>
        <br />

        <JoinComponent folk={props.type} alpha={props.alpha} />
      </div>
    );
  }
  if (insectNo === 1) {
    console.log(insectNo);
    return (
      <div className={styles.bkg}>
        <p>
          Our benefits will ensure your life will go with a buzz, if you choose
          this route you can enter{" "}
        </p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setInsectNo(2);
            }}
          >
            the green room
          </button>{" "}
        </p>
        <p>
          rewards will be plentyfull and we will be friendly and protective at
          all times.
        </p>
        <p>
          {" "}
          There is a question that needs answering first: how many times its
          weight can The{" "}
          <p>
            <button
              className={styles.choice}
              onClick={(event) => {
                setInsectNo(12);
              }}
            >
              Hercules Beetle carry?
            </button>
          </p>
        </p>
      </div>
    );
  }

  if (insectNo === 2) {
    return (
      <div className={styles.bkg}>
        <p>
          Did you know almost 90% of wild plants and 75% of leading global crops
          depend on insect pollination. One out of every three mouthfuls of our
          food depends on our work. Crops that depend on pollination are five
          times more valuable than those that do not. Enter the Green Room for
          an abundance of honey and good will. We are the most industrious and
          wonderful group. Enter the Green Room for an abundance of
        </p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setInsectNo(3);
            }}
          >
            honey and good will
          </button>
        </p>
      </div>
    );
  }
  if (insectNo === 3) {
    return (
      <div className={styles.bkg}>
        <p>
          If you have arrived here you will be in our amazing Green Room with
          webbed seating, honey nibble and delightful fun for
        </p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setInsectNo(4);
            }}
          >
            an amazing time.
          </button>
        </p>
      </div>
    );
  }
  if (insectNo === 4) {
    return (
      <div className={styles.bkg}>
        <p>
          We have many{" "}
          <a href="https://www.nationalinsectweek.co.uk/">
            festivals and events
          </a>{" "}
          in our group.
        </p>

        <p>
          The ants have a marching group and also have a games festival where
          they see{" "}
          <a href="https://www.youtube.com/watch?v=-6oKJ5FGk24">
            how many leaves each ant can carry
          </a>{" "}
          across the bridge.
        </p>
        <p>
          Betting gets quite hectic with this and{" "}
          <a href="http://www.bbc.com/earth/story/20170227-butterflies-perform-a-beautiful-courtship-dance">
            it's much fun.
          </a>{" "}
          The butterflies have many{" "}
          <a href="http://www.bbc.com/earth/story/20170227-butterflies-perform-a-beautiful-courtship-dance">
            dancing exhibitions
          </a>{" "}
          and you can even learn to{" "}
          <a href="https://www.youtube.com/watch?v=rKf6jsYlnN8">
            dance like a butterfly too.
          </a>
        </p>

        <p>
          {" "}
          The flies like to play it dangerously by trying to escape the spider's
          web in a set time, usually impossible but who knows? But you can play
          an escape game too as a ladybird{" "}
          <a href="http://www.free80sarcade.com/2600_Lady_Bug.php">here.</a>
        </p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setInsectNo(15);
            }}
          >
            Join us{" "}
          </button>
        </p>
        <p>and play this tournament as an Insect Folk or</p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setInsectNo(5);
            }}
          >
            Refuse at your peril.{" "}
          </button>
        </p>
      </div>
    );
  }
  if (insectNo === 5) {
    console.log(insectNo);
    return (
      <div className={styles.bkg}>
        <p>To refuse earns you a place in the </p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setInsectNo(6);
            }}
          >
            dark web of despair
          </button>
        </p>
      </div>
    );
  }
  if (insectNo === 6) {
    return (
      <div className={styles.bkg}>
        <p>
          You must retreat to your area unless you throw us an olive branch by
        </p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setInsectNo(7);
            }}
          >
            {" "}
            having another think about joining
          </button>{" "}
        </p>
        <p>or we will </p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setInsectNo(11);
            }}
          >
            eat all your cabbages.
          </button>
        </p>
      </div>
    );
  }
  if (insectNo === 7) {
    return (
      <div className={styles.bkg}>
        <p>
          Are you sure you aren't stuck in our web already? Imagine having
          spiders on your side? We can get them to build webs wherever you like.
          Want to fill your enemies bedroom with webs? We can do that! Do you
        </p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setInsectNo(15);
            }}
          >
            {" "}
            join the insect folk
          </button>
        </p>
        , or{" "}
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setInsectNo(9);
            }}
          >
            become a Loser?
          </button>
        </p>
      </div>
    );
  }

  if (insectNo === 8) {
    return (
      <div className={styles.bkg}>
        <p>
          Well as you ask, like all other insects, I have six legs and three
          main body parts: head, thorax (chest or mid section) and abdomen (tail
          end). I also have two antennae and an exoskeleton. We are a
          misunderstood butterfly we like to dance together and enjoy our five a
          day consisting of cabbages as they are tasty and succulent. As I said
          earlier we are calm and beautiful, but together with the other insects
          of Liverpool we are a power that spreads everywhere. You can
        </p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setInsectNo(1);
            }}
          >
            {" "}
            Join us for fab benefits.{" "}
          </button>
        </p>
        or{" "}
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setInsectNo(5);
            }}
          >
            Refuse at your peril..
          </button>
        </p>
      </div>
    );
  }
  if (insectNo === 9) {
    return (
      <div className={styles.bkg}>
        <p>You will be the sorry one, </p>
        <p>
          {" "}
          <button
            className={styles.choice}
            onClick={(event) => {
              setInsectNo(10);
            }}
          >
            float away now.
          </button>
        </p>
      </div>
    );
  }
  if (insectNo === 10) {
    return (
      <div className={styles.bkg}>
        <p>The end... doom...</p>
      </div>
    );
  }
  if (insectNo === 11) {
    return (
      <div className={styles.bkg}>
        <p>
          We are the most numerous and diverse of any Folk. If you decide to
          join another Folk, you should be warned not to mess with insects on
          our turf because we are everywhere and we may set our heavies on you.
        </p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setInsectNo(15);
            }}
          >
            {" "}
            join us
          </button>
        </p>
        <p>to win this tournament, or </p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setInsectNo(9);
            }}
          >
            become a Loser.
          </button>
        </p>
      </div>
    );
  }
  if (insectNo === 12) {
    return (
      <div className={styles.bkg}>
        <p>
          Also known as a rhinoceros beetle, the Hercules beetle is the longest
          beetle and is the strongest creature on Earth for its size — it can
          carry 850 times its weight! That’s like a person carrying seven
          elephants! So we insects are strong! And if you want to be a strong
          insect,{" "}
        </p>
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setInsectNo(1);
            }}
          >
            Join us for fab benefits.
          </button>{" "}
        </p>
        or{" "}
        <p>
          <button
            className={styles.choice}
            onClick={(event) => {
              setInsectNo(5);
            }}
          >
            Refuse at your peril.
          </button>
        </p>
      </div>
    );
  }
  if (insectNo === 15) {
    return (
      <div className={styles.bkg}>
        <p>
          You are one of us now! You can explore Liverpool with six legs on a
          much smaller scale than you are used to, can you feel the city
          expanding as you shrink? Fly or crawl around the map of Liverpool,
          imagine you are one of us and speak up. As individuals we might be
          tiny, but together in our millions we can be a powerful force for
          insect rights!
        </p>
        <br />

        <br />
        <Link className={styles.choice} to={"/" + props.type + ""}>
          Enter as one of the Insect Folk
        </Link>
      </div>
    );
  }
}
export default InsectChampion;

// <Link to={"/" + props.type + ""}>Enter as one of the Insect Folk</Link>
